import { FC } from 'react';
import { Switch } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface CreateMoreControlProps {
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}

const CreateMoreControl: FC<CreateMoreControlProps> = ({ checked, disabled, onChange }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <>
            <Switch size='small' checked={checked} disabled={disabled} onChange={onChange} />
            <small style={{ color: token.colorTextTertiary, margin: '0 0.625rem' }}>Create more</small>
        </>
    );
};

export default CreateMoreControl;
